import type {
  CreateNoteTemplateRequestBody,
  GetNotesTemplatesRequestBody,
  NoteTemplate,
  UpdateNoteTemplateAPIResponse,
  UpdateNoteTemplateRequestBody,
} from "@/common/types/notesTemplates";
import axiosClient from "@/lib/axios/axiosClient";

export const getNotesTemplates = async (
  body: GetNotesTemplatesRequestBody
): Promise<NoteTemplate[]> => {
  const response = await axiosClient.post<NoteTemplate[]>(
    "/get-templates",
    body,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};

export const createNoteTemplate = async (
  body: CreateNoteTemplateRequestBody
): Promise<string> => {
  const response = await axiosClient.post<string>(
    "/run-template-openai",
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};

export const updateNoteTemplate = async (
  body: UpdateNoteTemplateRequestBody
): Promise<UpdateNoteTemplateAPIResponse> => {
  const response = await axiosClient.post<UpdateNoteTemplateAPIResponse>(
    "/update-template",
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};
